import React from "react";

const ConfirmFrontdesk = ({
  handleFrontDeskToggle,
  frontDesk,
  setfrontdeskModal,
}) => {
  const isAssign = frontDesk === "N";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
      {/* Modal Card */}
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-2xl p-6 animate-fadeIn">
        
        {/* Title */}
        <h3 className="text-xl font-semibold text-gray-800 text-center">
          Confirm Action
        </h3>

        {/* Message */}
        <p className="mt-3 text-sm text-gray-500 text-center leading-relaxed">
          Are you sure you want to{" "}
          <span className="font-semibold text-gray-800">
            {isAssign ? "Assign" : "Unassign"}
          </span>{" "}
          this to Frontdesk?
        </p>

        {/* Buttons */}
        <div className="mt-6 flex gap-3">
          <button
            onClick={() => setfrontdeskModal(false)}
            className="w-1/2 py-2.5 rounded-xl border border-gray-300 text-gray-600 font-medium hover:bg-gray-100 transition duration-200"
          >
            Cancel
          </button>

          <button
            onClick={() => {
              handleFrontDeskToggle();
              setfrontdeskModal(false);
            }}
            className={`w-1/2 py-2.5 rounded-xl font-medium text-white transition duration-200 ${
              isAssign
                ? "bg-blue-500 hover:bg-blue-600"
                : "bg-red-500 hover:bg-red-600"
            }`}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmFrontdesk;